var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import ApartmentIcon from '@material-ui/icons/Apartment';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LockIcon from '@material-ui/icons/LockOutlined';
import { useSnackbar } from 'notistack';
import { dAxios, snackBarRsp, daFormatTrans, } from 'consts';
import { TextField, makeStyles, createStyles, Grid, Button, Typography, withStyles, Paper, IconButton, Box, } from '@material-ui/core';
import Input from 'component/material/Input';
import { 
// System User Info
setUserDataRedux, } from 'reducers/Login/action';
import { BoostrapSwiTabs } from 'component/Tabs/SwipeableTabs';
import { setLoadingRedux } from 'reducers/sharedata/action';
import { ImgBase64 } from 'component/material/Image';
import { getUserInfoRedux } from 'reducers/Login/selector';
import { useSelector, useDispatch } from 'react-redux';
import { APP_PATH, EZWAY, HOST, TRADEVAN } from 'config';
import { getToken } from 'main_api';
import { Autorenew } from '@material-ui/icons';
import { inputChange } from 'component/consts';
import { MasterGrids } from 'component/LHH/MasterGrids/MasterGrids';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import { ButtonContain } from 'component/material/ButtonContained/Button';
import PopDialog from 'component/LHH/PopDialog/PopDialog';
import DateEnum from 'component/material/DatePicker/enum';
import Axios from 'axios';
import InputPassword from 'component/material/Input/InputPassword';
import RequiredTextField from 'component/material/Input/RequiredTextField';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var Style = require('./login_style.module.css');
var mainStyle = require('main_style.module.css');
// style ---------------------------------------------
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            '& .MuiGrid-container': {
                margin: theme.spacing(1, 0),
                fontSize: '1em',
            },
            '& .MuiInputLabel-formControl': {
                fontSize: '1em',
            },
        },
    });
});
var StyleBtnGrid = withStyles({
    root: {
        marginBottom: '0 !important',
        '& .MuiGrid-item': {
            padding: '0 5px',
        },
        '& button': {
            width: '100%',
            fontSize: '1.3rem',
        },
    },
})(Grid);
// component ---------------------------------------------
var IconTextField = function (props) {
    var LeftIcon = props.LeftIcon, children = props.children;
    return (React.createElement(Grid, { container: true, alignItems: "center" },
        React.createElement(Grid, { item: true, style: { margin: '10px 8px 0' } }, LeftIcon),
        React.createElement(Grid, { xs: true, item: true }, children)));
};
var CaptchaTextField = function (props) {
    var onChange = props.onChange, verify = props.verify, prop = __rest(props, ["onChange", "verify"]);
    var _a = useState(''), errorText = _a[0], setErrorText = _a[1];
    var inputRef = useRef();
    var inputVerify = function () { return setErrorText(inputRef.current.validationMessage); };
    var handleChange = onChange
        ? function (e) {
            onChange(e);
            inputVerify();
        }
        : inputVerify;
    useEffect(function () {
        if (verify) {
            inputVerify();
        }
    }, [verify]);
    return (React.createElement(TextField, __assign({}, prop, { inputRef: inputRef, required: true, onChange: handleChange, error: errorText.length > 0, helperText: errorText, FormHelperTextProps: { style: { textAlign: 'right' } } })));
};
export var LoginInput = function (props) {
    var dLoginData = {
        lang: 'TW',
        idNo: '',
        userId: '',
        userPwd: '',
        userType: '',
        eid: '',
        captcha: '',
        code: '',
        result: '',
        personCheck: 'N',
    };
    var _a = useState(dLoginData), loginData = _a[0], setLoginData = _a[1];
    var dispatch = useDispatch();
    var userInfo = useSelector(getUserInfoRedux);
    var loginMessage = props.loginMessage, handleLogin = props.handleLogin, intra = props.intra, intra_invoice = props.intra_invoice, history = props.history, handleChangePwd = props.handleChangePwd, handleAccountCheck = props.handleAccountCheck;
    var classes = useStyles();
    var _b = useState(0), tabIdx = _b[0], setTabIdx = _b[1];
    var _c = useState(false), veirfy = _c[0], setVeirfy = _c[1];
    var _d = useState(false), PersonShow = _d[0], setPersonShow = _d[1];
    var _e = useState(''), divText = _e[0], setDivText = _e[1];
    var _f = useState(false), showAnn = _f[0], setShowAnn = _f[1];
    var handleSuccess = function () {
        setShowAnn(false);
        saveAnnouncement();
        loginData.personCheck = 'Y';
        handleLogin(loginData)(); // 登入
    };
    var handleClose = function () {
        setShowAnn(false);
        if (loginData.personCheck !== 'Y')
            enqueueSnackbar('請確認服務條款內容。');
    };
    var _g = useState(''), verifyImg = _g[0], setVerifyImg = _g[1];
    var _h = useState(''), verifyCode = _h[0], setVerifyCode = _h[1];
    var _j = useState(''), verifyResult = _j[0], setVerifyResult = _j[1];
    var _k = useState(''), flowTID = _k[0], setFlowTID = _k[1];
    var _l = useState(''), transactionId = _l[0], setTransactionId = _l[1];
    var _m = useState(''), checkResponse = _m[0], setCheckResponse = _m[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var saveAnnouncement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dAxios('post', HOST + "v1/system/web_announcement", { userId: loginData.userId, idNo: loginData.idNo, userPwd: loginData.userPwd, code: loginData.code, captcha: loginData.captcha }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        setLoginData(__assign(__assign({}, loginData), { personCheck: 'Y' }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (loginData.personCheck === 'Y') {
            handleLogin(loginData)();
        }
    }, [loginData.personCheck === 'Y']);
    var PersonDlg = function (props) {
        var enqueueSnackbar = useSnackbar().enqueueSnackbar;
        var show = props._show[0], onConfirm = props.onConfirm, onClose = props.onClose;
        useEffect(function () {
            getWebAnnouncement();
        }, [PersonShow !== false]);
        var getWebAnnouncement = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (PersonShow === false) {
                            return [2 /*return*/];
                        }
                        setPersonShow(false);
                        return [4 /*yield*/, dAxios('post', HOST + "v1/system/web_get_announcement", { userId: loginData.userId, idNo: loginData.idNo, userPwd: loginData.userPwd, code: loginData.code, captcha: loginData.captcha, type: 'C', lang: 'TW' }, enqueueSnackbar)];
                    case 1:
                        response = _a.sent();
                        if (!snackBarRsp(enqueueSnackbar, response)) {
                            return [2 /*return*/];
                        }
                        if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                            setDivText(response.data.data[0].context);
                            setShowAnn(true);
                        }
                        if ((response === null || response === void 0 ? void 0 : response.data.status) === 'N') {
                            if (loginData.personCheck === 'Y') {
                                handleLogin(loginData)();
                            }
                            setLoginData(__assign(__assign({}, loginData), { personCheck: 'Y' }));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //handleLogin(loginData)
        var DlgConfig = {
            show: showAnn,
            escExit: true,
            width: '50vw',
            title: '　　',
            handleExit: onClose,
            children: (React.createElement("div", null,
                React.createElement("div", { 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: { __html: divText }, style: { fontSize: '1.2em' } }),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { variant: "outlined", onClick: onClose }, "\u53D6\u6D88"),
                    React.createElement(ButtonContain, { type: "submit", onClick: handleSuccess }, "\u540C\u610F")))),
        };
        return React.createElement(PopDialog, __assign({}, DlgConfig));
    };
    var ModifyPwdDlg = function (props) {
        var dispatch = useDispatch();
        var enqueueSnackbar = useSnackbar().enqueueSnackbar;
        var _a = props.NeedOrigPwd, NeedOrigPwd = _a === void 0 ? false : _a, _b = props._show, show = _b[0], setShow = _b[1], getCaptcha = props.getCaptcha;
        var handleExit = function () {
            setShow(false);
            getCaptcha(); // ⬅ 視窗關閉時刷新驗證碼
        };
        var dStoreData = {
            lang: 'TW',
            userId: loginData.userId,
            userType: loginData.userType,
            origPwd: '',
            newPwd: '',
            newPwd2: '',
        };
        var _c = useState(dStoreData), storeData = _c[0], setStoreData = _c[1];
        var _d = useState(''), newPwd2Err = _d[0], setNewPwd2Err = _d[1];
        var _e = useState(false), verifyError = _e[0], setVerifyError = _e[1];
        var UpdateData = function (updateObj) {
            return setStoreData(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
        };
        var changePwdCheck = function () {
            setVerifyError(true);
            if (!storeData.origPwd ||
                !storeData.newPwd ||
                !storeData.newPwd2 ||
                storeData.newPwd !== storeData.newPwd2 ||
                storeData.origPwd.length < 5 ||
                storeData.newPwd.length < 5) {
                return false;
            }
            return true;
        };
        var handlechangePwd = function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (e && e.preventDefault) {
                            e.preventDefault();
                        }
                        if (!changePwdCheck()) {
                            return [2 /*return*/];
                        }
                        dispatch(setLoadingRedux(1));
                        payload = __assign(__assign({}, storeData), { userId: loginData.userId, userType: loginData.userType });
                        return [4 /*yield*/, dAxios('post', HOST + "v2/user/other/secret", payload, enqueueSnackbar)];
                    case 1:
                        response = _a.sent();
                        dispatch(setLoadingRedux(-1));
                        if (!snackBarRsp(enqueueSnackbar, response)) {
                            return [2 /*return*/];
                        }
                        if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y')
                            setShow(function (prev) { return !prev; });
                        getCaptcha();
                        return [2 /*return*/];
                }
            });
        }); };
        var QueryConds = [
            {
                t: '*原密碼',
                child: (React.createElement(InputPassword, { className: mainStyle.input, placeholder: "\u8ACB\u8F38\u5165\u539F\u5BC6\u78BC", minLength: 5, maxLength: 30, value: storeData.origPwd || '', name: "origPwd", verifyBeforeChange: verifyError, onChange: inputChange(UpdateData) })),
            },
            {
                t: '*新密碼',
                child: (React.createElement(InputPassword, { className: mainStyle.input, placeholder: "\u8ACB\u8F38\u5165\u65B0\u5BC6\u78BC", minLength: 12, maxLength: 30, value: storeData.newPwd || '', name: "newPwd", verifyBeforeChange: verifyError, helperText: React.createElement("span", { style: { color: 'red', fontSize: 15 } },
                        React.createElement("div", null,
                            "\u5BC6\u78BC\u8A2D\u5B9A\u9700\u7B26\u5408\u4E0B\u52176\u9805\u898F\u5247 ",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u5305\u542B\u82F1\u6587\u5927\u5BEB\u3002 ",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u5305\u542B\u82F1\u6587\u5C0F\u5BEB\u3002 ",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u5305\u542B\u6578\u5B57\u3002 ",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u5305\u542B\u7279\u6B8A\u7B26\u865F\u3010\u50C5\u9650\uFF20\uFF04\uFF01\uFF05\uFF0A\uFF1F\uFF03\u3011 \u3002",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u5BC6\u78BC\u4E0D\u5F97\u8207\u524D3\u6B21\u76F8\u540C ",
                            React.createElement("br", null),
                            "\u00A0\u00A0\uFF0E\u9577\u5EA6\u81F3\u5C1112~30\u78BC\u5B57\u5143\u3002")), onChange: inputChange(UpdateData) })),
            },
            {
                t: '*再次輸入新密碼',
                child: (React.createElement(InputPassword, { className: mainStyle.input, placeholder: "\u8ACB\u518D\u6B21\u8F38\u5165\u65B0\u5BC6\u78BC", minLength: 12, maxLength: 30, value: storeData.newPwd2 || '', name: "newPwd2", verifyBeforeChange: verifyError, error: newPwd2Err.length > 0, helperText: newPwd2Err, onChange: function (e) {
                        if (storeData.newPwd !== e.target.value)
                            setNewPwd2Err('密碼不符。');
                        else
                            setNewPwd2Err('');
                        inputChange(UpdateData)(e);
                    } })),
            }
        ];
        var closeDialog = function () {
            setShow(false);
            getCaptcha(); //每次關閉視窗時都刷新驗證碼
        };
        var DlgConfig = {
            show: show,
            escExit: true,
            width: '30vw',
            title: '修改密碼',
            handleExit: closeDialog,
            children: (React.createElement("form", { onInvalid: function () { return setVerifyError(true); }, onSubmit: handlechangePwd },
                React.createElement(MasterGrids, { mGrids: QueryConds, md: [4, 8] }),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { variant: "outlined", onClick: closeDialog }, "\u53D6\u6D88"),
                    React.createElement(ButtonContain, { type: "submit" }, "\u5132\u5B58")))),
        };
        return React.createElement(PopDialog, __assign({}, DlgConfig));
    };
    var PwdExpirationDlg = function (props) {
        var _a = props._show, show = _a[0], setShow = _a[1], msg = props.msg, onConfirm = props.onConfirm, onCancel = props.onCancel, loginUrl = props.loginUrl, history = props.history, dispatch = props.dispatch, response = props.response;
        var config = {
            show: show,
            escExit: true,
            width: '20vw',
            title: '密碼即將到期',
            handleExit: function () {
                setShow(false);
                onCancel();
                handlePostLoginSuccess(response, loginUrl, history, dispatch); //成功登入流程
            },
            children: (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "body1", style: { paddingBottom: '1em', fontSize: '16px', whiteSpace: 'pre-line' } }, msg + '\n請盡快進行密碼變更，避免日後無法登入作業。'),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { onClick: function () {
                            setShow(false);
                            onConfirm();
                        } }, "\u4FEE\u6539\u5BC6\u78BC"),
                    React.createElement(ButtonContain, { variant: "outlined", onClick: function () {
                            setShow(false);
                            onCancel();
                            handlePostLoginSuccess(response, loginUrl, history, dispatch); //成功登入流程
                        } }, "\u7A0D\u5F8C\u4FEE\u6539")))),
        };
        return React.createElement(PopDialog, __assign({}, config));
    };
    var AccountExpirationDlg = function (props) {
        var _a = props._show, show = _a[0], setShow = _a[1], msg = props.msg, onConfirm = props.onConfirm, onCancel = props.onCancel, loginUrl = props.loginUrl, history = props.history, dispatch = props.dispatch, response = props.response, checkAccountExpiryShow = props.checkAccountExpiryShow;
        var _b = useState(msg), displayMsg = _b[0], setDisplayMsg = _b[1];
        // 如果 props.msg 有可能從外部改變，可以用 useEffect 同步
        useEffect(function () {
            setDisplayMsg(msg);
        }, [msg]);
        var handleAccountCheck = function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response_1, flowTID_1, transactionId_1, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (e && e.preventDefault) {
                            e.preventDefault();
                        }
                        dispatch(setLoadingRedux(1));
                        payload = {
                            flowTID: checkAccountExpiryShow.flowTID,
                            userId: loginData.userId,
                            lang: 'TW',
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dAxios('post', HOST + "v1/user/accountCheckN", payload, enqueueSnackbar)];
                    case 2:
                        response_1 = _d.sent();
                        dispatch(setLoadingRedux(-1));
                        if (!snackBarRsp(enqueueSnackbar, response_1)) {
                            return [2 /*return*/, null];
                        }
                        if ((_a = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _a === void 0 ? void 0 : _a.msg) {
                            setDisplayMsg(response_1.data.msg);
                        }
                        if (((_b = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _b === void 0 ? void 0 : _b.status) === 'S') {
                            setCheckResponse('S');
                        }
                        if (((_c = response_1 === null || response_1 === void 0 ? void 0 : response_1.data) === null || _c === void 0 ? void 0 : _c.status) === 'W') {
                            flowTID_1 = response_1.data.data.flowTID;
                            setFlowTID(flowTID_1);
                            transactionId_1 = response_1.data.data.vercodeTransactionId;
                            setTransactionId(transactionId_1);
                        }
                        return [2 /*return*/, response_1];
                    case 3:
                        error_1 = _d.sent();
                        dispatch(setLoadingRedux(-1));
                        console.error("accountCheckN API Error:", error_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var config = {
            show: show,
            escExit: true,
            width: '20vw',
            title: '帳號已逾期，請重新驗證',
            handleExit: function () {
                setShow(false);
                setCheckResponse('');
                onCancel();
            },
            children: (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "body1", style: { paddingBottom: '1em', fontSize: '16px', whiteSpace: 'pre-line' } }, displayMsg),
                checkResponse !== 'S' && (React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                            var res;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, handleAccountCheck(e)];
                                    case 1:
                                        res = _c.sent();
                                        // B. 判斷 response 中的 status 是否為 'W'
                                        if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 'W') {
                                            // 成功：關閉彈窗並執行原有 confirm
                                            setShow(false);
                                            onConfirm();
                                        }
                                        else {
                                            // 失敗：不關閉彈窗，並更新提示文字為 response 帶回來的 msg
                                            if ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.msg) {
                                                setDisplayMsg(res.data.msg);
                                            }
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, "\u662F"),
                    React.createElement(ButtonContain, { variant: "outlined", onClick: function () {
                            setShow(false);
                            onCancel();
                        } }, "\u5426"))))),
        };
        return React.createElement(PopDialog, __assign({}, config));
    };
    var AccountCheckVerCodeDlg = function (props) {
        var dispatch = useDispatch();
        var enqueueSnackbar = useSnackbar().enqueueSnackbar;
        var checkAccountExpiryShow = props.checkAccountExpiryShow, _a = props.NeedOrigPwd, NeedOrigPwd = _a === void 0 ? false : _a, _b = props._show, show = _b[0], setShow = _b[1], getCaptcha = props.getCaptcha;
        var handleExit = function () {
            setShow(false);
            getCaptcha(); // ⬅ 視窗關閉時刷新驗證碼
        };
        var dStoreData = {
            transactionId: transactionId,
            verCode: '',
            flowTID: flowTID,
            deviceType: 'W',
        };
        var _c = useState(dStoreData), storeData = _c[0], setStoreData = _c[1];
        var _d = useState(''), newPwd2Err = _d[0], setNewPwd2Err = _d[1];
        var _e = useState(false), verifyError = _e[0], setVerifyError = _e[1];
        var UpdateData = function (updateObj) {
            return setStoreData(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
        };
        var changePwdCheck = function () {
            setVerifyError(true);
            if (!storeData.verCode) {
                return false;
            }
            return true;
        };
        var handlechangePwd = function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (e && e.preventDefault) {
                            e.preventDefault();
                        }
                        if (!changePwdCheck()) {
                            return [2 /*return*/];
                        }
                        dispatch(setLoadingRedux(1));
                        payload = __assign(__assign({}, storeData), { userId: loginData.userId, userType: loginData.userType });
                        return [4 /*yield*/, dAxios('post', HOST + "v1/user/accountCheck/verify", payload, enqueueSnackbar)];
                    case 1:
                        response = _a.sent();
                        dispatch(setLoadingRedux(-1));
                        if (!snackBarRsp(enqueueSnackbar, response)) {
                            return [2 /*return*/];
                        }
                        if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y')
                            setShow(function (prev) { return !prev; });
                        getCaptcha();
                        return [2 /*return*/];
                }
            });
        }); };
        var QueryConds = [
            {
                t: '*驗證碼',
                child: (React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, sm: true },
                        React.createElement(Input, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, inputProps: { minLength: 6, maxLength: 6 }, placeholder: "\u8ACB\u8F38\u5165 6 \u4F4D\u9A57\u8B49\u78BC", value: storeData.verCode || '', name: "verCode", onChange: inputChange(UpdateData) })),
                    React.createElement(Grid, { item: true, sm: true, className: mainStyle.flexVerticalCenter },
                        React.createElement("span", { style: { marginLeft: 5 } }, " \u9A57\u8B49\u78BC\u6700\u591A\u91CD\u767C\u4E8C\u6B21 ")))),
            },
        ];
        var closeDialog = function () {
            setShow(false);
            getCaptcha(); //每次關閉視窗時都刷新驗證碼
        };
        var DlgConfig = {
            show: show,
            escExit: true,
            width: '30vw',
            title: '帳號已逾期',
            handleExit: closeDialog,
            children: (React.createElement("form", { onInvalid: function () { return setVerifyError(true); }, onSubmit: handlechangePwd },
                React.createElement(MasterGrids, { mGrids: QueryConds, md: [4, 8] }),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { variant: "outlined", onClick: closeDialog }, "\u53D6\u6D88"),
                    React.createElement(ButtonContain, { type: "submit" }, "\u5132\u5B58")))),
        };
        return React.createElement(PopDialog, __assign({}, DlgConfig));
    };
    var handlePostLoginSuccess = function (response, loginUrl, history, dispatch) {
        window.sessionStorage.setItem('jwt', "Bearer " + response.data.data.token);
        Axios.defaults.headers.Authorization = "Bearer " + response.data.data.token;
        window.sessionStorage.setItem('userId', response.data.data.userId);
        window.sessionStorage.setItem('loginTime', daFormatTrans(new Date(), DateEnum.daTiFormatP));
        dispatch(setUserDataRedux({
            userId: response.data.data.userId,
            userName: '',
        }));
        if (loginUrl === 'inv-login') {
            return;
        }
        history.push(APP_PATH);
    };
    var loginErrorMessageContent = '';
    switch (loginMessage) {
        case 'disable':
            loginErrorMessageContent = '此用戶代碼已被停用，請洽資訊人員。';
            break;
        case 'isLocked':
            loginErrorMessageContent = '此用戶代碼已被鎖定，請洽資訊人員。';
            break;
        case 'expired':
            loginErrorMessageContent = '此用戶代碼使用期限已逾期，請洽資訊人員。';
            break;
        case 'wrongAccountPassword':
            loginErrorMessageContent = '用戶代碼密碼錯誤！';
            break;
        default:
            loginErrorMessageContent = loginMessage;
            break;
    }
    var handleInputChange = function (e) {
        var _a;
        loginData.code = verifyCode;
        setLoginData(__assign(__assign({}, loginData), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    };
    var getCaptcha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, base64Img, code, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dAxios("get", HOST + "v1/system/verfiryCode", {}, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (response) {
                        result = response.data.status;
                        loginData.result = result;
                        setVerifyResult(result);
                        // console.log(verifyResult);
                        if (result === "Y" && response && response.data.data) {
                            base64Img = response === null || response === void 0 ? void 0 : response.data.data.image;
                            code = response === null || response === void 0 ? void 0 : response.data.data.code;
                            setVerifyCode(code);
                            setVerifyImg("data:image/png;base64, " + base64Img);
                        }
                        else if (result === "N") {
                            message = response.data.msg;
                            enqueueSnackbar(message);
                        }
                    }
                    ;
                    return [2 /*return*/];
            }
        });
    }); };
    var IdPassword = (React.createElement(React.Fragment, null,
        React.createElement(IconTextField, { LeftIcon: React.createElement(PersonOutlineIcon, { color: "disabled", fontSize: "large" }) },
            React.createElement(RequiredTextField
            // label="請輸入使用者帳號"
            , { 
                // label="請輸入使用者帳號"
                placeholder: "\u8ACB\u8F38\u5165\u4F7F\u7528\u8005\u5E33\u865F", className: mainStyle.input, fullWidth: true, verify: veirfy, name: "userId", value: loginData.userId, onChange: handleInputChange })),
        React.createElement(IconTextField, { LeftIcon: React.createElement(LockIcon, { color: "disabled", fontSize: "large" }) },
            React.createElement(InputPassword, { className: mainStyle.input, placeholder: "\u8ACB\u8F38\u5165\u4F7F\u7528\u8005\u5BC6\u78BC", minLength: 5, fullWidth: true, maxLength: 30, value: loginData.userPwd, name: "userPwd", onChange: handleInputChange }))));
    var InvoiceIdPassword = (React.createElement(React.Fragment, null,
        React.createElement(IconTextField, { LeftIcon: React.createElement(PersonOutlineIcon, { color: "disabled", fontSize: "large" }) },
            React.createElement(RequiredTextField
            // label="請輸入使用者帳號"
            , { 
                // label="請輸入使用者帳號"
                placeholder: "\u8ACB\u8F38\u5165\u4F7F\u7528\u8005\u5E33\u865F", className: mainStyle.input, fullWidth: true, verify: veirfy, name: "userId", value: loginData.userId, onChange: handleInputChange })),
        React.createElement(IconTextField, { LeftIcon: React.createElement(LockIcon, { color: "disabled", fontSize: "large" }) },
            React.createElement(InputPassword, { className: mainStyle.input, placeholder: "\u8ACB\u8F38\u5165\u4F7F\u7528\u8005\u5BC6\u78BC", minLength: 5, maxLength: 30, fullWidth: true, value: loginData.userPwd, name: "userPwd", onChange: handleInputChange }))));
    var showImg = verifyResult === 'Y' ? (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(CaptchaTextField, { label: "\u8ACB\u8F38\u5165\u9A57\u8B49\u78BC", 
                // fullWidth
                verify: veirfy, name: "captcha", value: loginData.captcha, onChange: handleInputChange }),
            React.createElement(ImgBase64, { src: verifyImg, style: { maxHeight: '100px' }, download: false }),
            React.createElement(IconButton, { onClick: getCaptcha, style: { color: 'white', padding: '0px' } },
                React.createElement(IconTextField, { LeftIcon: React.createElement(Autorenew, { color: "disabled", fontSize: "large" }) }))))) : (React.createElement(React.Fragment, null));
    var ForgetUser = (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, style: { margin: 0 } },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('usernameRecovery'); } }, "\u5FD8\u8A18\u5E33\u865F\uFF1F")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('resetPassword'); } }, "\u5FD8\u8A18\u5BC6\u78BC\uFF1F")))));
    var ForgetCustomerUser = (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, style: { margin: 0 } },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('usernameRecovery'); } }, "\u5FD8\u8A18\u5E33\u865F\uFF1F")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('cResetPassword', {
                        userType: 'CUSTOMER'
                    }); } }, "\u5FD8\u8A18\u5BC6\u78BC\uFF1F")))));
    var ForgetCustomsUser = (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, style: { margin: 0 } },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('usernameRecovery'); } }, "\u5FD8\u8A18\u5E33\u865F\uFF1F")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('cResetPassword', {
                        userType: 'CUSTOMS'
                    }); } }, "\u5FD8\u8A18\u5BC6\u78BC\uFF1F")))));
    var ForgetTradevanUser = (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, style: { margin: 0 } },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('usernameRecovery'); } }, "\u5FD8\u8A18\u5E33\u865F\uFF1F")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(Button, { color: "primary", onClick: function () { return history.push('cResetPassword', {
                        userType: 'TRADEVAN'
                    }); } }, "\u5FD8\u8A18\u5BC6\u78BC\uFF1F")))));
    var IntraBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () {
                        return setLoginData(function (prev) { return (__assign(__assign({}, prev), { userId: '', userPwd: '' })); });
                    } }, "\u6E05\u9664")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { type: "submit", onClick: function () { return setVeirfy(true); } }, "\u767B\u5165"))),
        ForgetUser));
    var ExtraBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return history.push('register'); } }, "\u8A3B\u518A")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { type: "submit", onClick: function () { return setVeirfy(true); } }, "\u767B\u5165"))),
        ForgetUser));
    var CustomerBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return history.push('register'); } }, "\u8A3B\u518A")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { onClick: function () { return setPersonShow(true); } }, "\u767B\u5165"))),
        ForgetCustomerUser));
    var CustomsBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return history.push('register'); } }, "\u8A3B\u518A")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { onClick: handleLogin(loginData) }, "\u767B\u5165"))),
        ForgetCustomsUser));
    var TradevanBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true },
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return history.push('register'); } }, "\u8A3B\u518A")),
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { onClick: handleLogin(loginData) }, "\u767B\u5165"))),
        ForgetTradevanUser));
    var InvoiceBtns = (React.createElement(React.Fragment, null,
        React.createElement(StyleBtnGrid, { container: true },
            React.createElement(Grid, { item: true, xs: true, style: { textAlign: 'right' } },
                React.createElement(ButtonContain, { type: "submit", onClick: function () { return setVeirfy(true); } }, "\u78BA\u8A8D"))),
        ForgetUser));
    var InvoiceTabs = [
        {
            title: '電商',
            userType: EZWAY,
            content: (React.createElement("form", { className: classes.root, onSubmit: handleLogin(loginData) },
                InvoiceIdPassword,
                showImg,
                InvoiceBtns)),
        },
    ];
    var IntraTabs = [
        {
            title: '關貿',
            userType: TRADEVAN,
            content: (React.createElement("form", { className: classes.root, onSubmit: handleLogin(loginData) },
                IdPassword,
                showImg,
                TradevanBtns)),
        },
        {
            title: '機關',
            userType: 'CUSTOMS',
            content: (React.createElement("form", { className: classes.root, onSubmit: handleLogin(loginData) },
                IdPassword,
                showImg,
                CustomsBtns)),
        },
    ];
    var ExtraTabs = [
        {
            title: '一般用戶',
            userType: 'EZWAY',
            content: (React.createElement("form", { className: classes.root, onSubmit: handleLogin(loginData) },
                IdPassword,
                showImg,
                ExtraBtns)),
        },
        {
            title: '業者',
            userType: 'CUSTOMER',
            content: (React.createElement("form", { className: classes.root, onSubmit: handleLogin(loginData) },
                React.createElement(IconTextField, { LeftIcon: React.createElement(ApartmentIcon, { color: "disabled", fontSize: "large" }) },
                    React.createElement(RequiredTextField
                    // label="請輸入公司統一編號"
                    , { 
                        // label="請輸入公司統一編號"
                        placeholder: "\u8ACB\u8F38\u5165\u516C\u53F8\u7D71\u4E00\u7DE8\u865F", className: mainStyle.input, fullWidth: true, verify: veirfy, name: "idNo", value: loginData.idNo, onChange: handleInputChange, inputProps: { minLength: 4 } })),
                IdPassword,
                showImg,
                CustomerBtns)),
        },
    ];
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getToken(enqueueSnackbar)];
                case 1:
                    _a.sent();
                    getCaptcha();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setLoginData(__assign(__assign({}, loginData), { userType: (intra ? IntraTabs : intra_invoice ? InvoiceTabs : ExtraTabs)[tabIdx].userType }));
    }, [tabIdx]);
    useEffect(function () {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userType) {
            var tabContent = intra ? IntraTabs : intra_invoice ? InvoiceTabs : ExtraTabs;
            var tabIndex = tabContent.findIndex(function (obj) { return obj.userType === userInfo.userType; });
            setTabIdx(tabIndex > -1 ? tabIndex : 0);
        }
        init();
    }, []);
    useEffect(function () {
        setVerifyResult(loginData.result);
    }, [loginData.result]);
    return (React.createElement("div", null,
        React.createElement(PersonDlg, { _show: [PersonShow, setPersonShow], onConfirm: handleSuccess, onClose: handleClose }),
        React.createElement(ModifyPwdDlg, { _show: [props.modifyPwdShow, props.setModifyPwdShow], storeData: props.storeData, setStoreData: props.setStoreData, handleChangePwd: handleChangePwd, getCaptcha: getCaptcha }),
        React.createElement(AccountCheckVerCodeDlg, { _show: [props.accountExpiryShow, props.setAccountExpiryShow], storeData: props.storeData, setStoreData: props.setStoreData, handleChangePwd: handleChangePwd, getCaptcha: getCaptcha, checkAccountExpiryShow: props.checkAccountExpiryShow }),
        React.createElement(PwdExpirationDlg, { _show: [props.checkChangePwdShow.show, function (v) { return props.setCheckChangePwdShow(__assign(__assign({}, props.checkChangePwdShow), { show: v })); }], msg: props.checkChangePwdShow.msg, onConfirm: function () { return props.setModifyPwdShow(true); }, onCancel: function () { }, loginUrl: props.loginUrl, history: props.history, dispatch: dispatch, response: props.pwdExpireResp }),
        React.createElement(AccountExpirationDlg, { _show: [props.checkAccountExpiryShow.show, function (v) { return props.setCheckAccountExpiryShow(__assign(__assign({}, props.checkAccountExpiryShow), { show: v })); }], msg: props.checkAccountExpiryShow.msg, onConfirm: function () { return props.setAccountExpiryShow(true); }, onCancel: function () { }, loginUrl: props.loginUrl, history: props.history, dispatch: dispatch, response: props.pwdExpireResp, handleAccountCheck: props.handleAccountCheck, checkAccountExpiryShow: props.checkAccountExpiryShow }),
        React.createElement(Paper, { elevation: 3 },
            React.createElement(BoostrapSwiTabs, { TAB_IDX: [tabIdx, setTabIdx], width: 350, 
                // contentheight={245}
                onChange: function (e, tabIdxData) {
                    setTabIdx(tabIdxData);
                    setVeirfy(false);
                }, tabContent: intra ? IntraTabs : intra_invoice ? InvoiceTabs : ExtraTabs }))));
};
export default LoginInput;
